import styled, { css } from "react-emotion/macro"
import { color, mq } from "../../styles/variables"

export const Wrapper = styled("footer")`
  background-color: ${color.rgb.white[0]};
  font-size: 14px;
  text-align: center;
  border-top: 1px solid ${color.rgb.gray[2]};
  margin-top: 60px;
  color: ${color.rgb.black[0]};

  h4 {
    text-transform: uppercase;
    font-size: 16px;
    margin-bottom: 0;
  }

  .footer-form {
    font-size: 16px;
    h4 {
      + p {
        margin-bottom: 5px;
      }
    }
  }

  .main-container {
    padding-top: 45px;
    padding-bottom: 45px;
  }

  .brand-right {
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    max-width: 605px;
  }

  .brand-left-top {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo {
    width: 113px;
    max-width: 100%;
    min-width: 75px;
  }

  .logo-wrapper {
    padding-right: 20px;
  }

  .logo-description {
    font-size: 16px;
    text-align: left;
  }

  svg {
    width: 20px;
  }

  .link-w-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    color: ${color.rgb.white[0]};

    .icon-wrapper {
      margin-right: 8px;
      border-radius: 100%;
      background-color: ${color.rgb.orange[0]};
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    svg path {
      fill: ${color.rgb.black[0]};
    }
  }

  a {
    font-weight: 400;
    line-height: 36px;
  }

  .contact {
    padding-top: 60px;
    padding-bottom: 60px;
    background-color: ${color.rgb.black[0]};

    &,
    h4 {
      color: ${color.rgb.white[0]};
    }

    > div > div {
      margin-bottom: 30px;
    }
  }

  .social {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;

    a {
      border-radius: 100%;
      background-color: ${color.rgb.orange[0]};
      width: 22px;
      height: 22px;
      padding: 9px;
      text-align: center;
      margin: 0 10px 0;

      &.youtube {
        padding: 5px;
        width: 30px;
        height: 30px;
      }

      &.facebook img {
        height: 28px;
        margin-top: 3px;
        margin-left: 7px;
      }
    }
  }

  ${mq.md(css`
    text-align: left;

    .brand-container {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      > div {
        width: 50%;
      }

      .logo-wrapper img {
        width: 122px;
        min-width: 122px;
        padding-right: 20px;
      }
    }

    .brand-right {
      margin-top: 0;
      margin-right: 0;
    }

    .brand-left {
      padding-right: 90px;
    }

    .link-w-icon {
      justify-content: flex-start;
    }

    .contact > div {
      display: flex;
      justify-content: space-between;

      .social {
        justify-content: flex-start;

        a:first-of-type {
          margin-left: 0;
        }
      }
    }
  `)};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer/style.js